interface StatCardProps {
  label: string;
  value: string | number;
  icon: string;
  sub?: string;
  color?: string;
}

export default function StatCard({ label, value, icon, sub, color = 'text-rose-500' }: StatCardProps) {
  return (
    <div className="bg-white dark:bg-stone-900 rounded-xl border border-stone-100 dark:border-stone-800 p-5">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-widest text-stone-400">{label}</span>
        <div className={`w-8 h-8 flex items-center justify-center rounded-lg bg-stone-50 dark:bg-stone-800 ${color}`}>
          <i className={icon} />
        </div>
      </div>
      <div className="text-3xl font-bold text-stone-800 dark:text-stone-100 font-mono">{value}</div>
      {sub && <div className="text-xs text-stone-400 mt-1">{sub}</div>}
    </div>
  );
}
